import React from "react";
import Favorite from "./Favorite";

const TeamName = (props) => {
  return (
    <div className="team">
      {props.name}
    </div>
  );
};

export default TeamName;
